export const stepIds = {
  title: 'title',
  basicDetails: 'basicDetails'
} as const;

export type StepIds = (typeof stepIds)[keyof typeof stepIds];
